import { Menu, WorkspaceBadge } from '@cinesend/ui-kit'
import { CaretDown } from '@phosphor-icons/react'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

const BADGE_COLORS = ['blue', 'yellow', 'green']

const cycleName = (cycle) => cycle?.name ?? cycle?.description ?? ''

const cycleInitial = (cycle) => cycleName(cycle).trim().charAt(0).toUpperCase() || '?'

const CycleDropdown = ({ airlineID, cycleID, setCycle }) => {
  const { data: cycles, isLoading } = useQuery(['cycles', `?airlineID=${airlineID}`])
  const cycle = cycles?.find((item) => item.id === cycleID)
  const cycleIndex = cycles?.findIndex((item) => item.id === cycleID) ?? -1

  useEffect(() => {
    if (!isLoading && !cycle) {
      setCycle(null)
    }
  }, [isLoading, cycle])

  if (isLoading) {
    return null
  }

  const label = cycle ? cycleName(cycle) : 'Select cycle'
  const color = BADGE_COLORS[Math.max(cycleIndex, 0) % BADGE_COLORS.length]

  return (
    <Menu
      align='start'
      trigger={
        <button
          type='button'
          className='cs-workspace-switcher cs-workspace-switcher--compact cs-workspace-menu__trigger'
        >
          <span className='cs-workspace-switcher__leading' aria-hidden='true'>
            <WorkspaceBadge color={color}>{cycle ? cycleInitial(cycle) : '?'}</WorkspaceBadge>
          </span>
          <span className='cs-workspace-switcher__label'>{label}</span>
          <span className='cs-workspace-switcher__trailing' aria-hidden='true'>
            <span className='cs-menu-caret'>
              <CaretDown size={20} weight='regular' />
            </span>
          </span>
        </button>
      }
      items={(cycles ?? []).map((item, index) => ({
        id: String(item.id),
        label: `${cycleName(item)} (${item.status_label})`,
        icon: <WorkspaceBadge color={BADGE_COLORS[index % BADGE_COLORS.length]}>{cycleInitial(item)}</WorkspaceBadge>,
        selected: item.id === cycleID,
        onSelect: () => setCycle(item.id),
      }))}
    />
  )
}

export default CycleDropdown
